
/**
 * Overrides the style of the Autocomplete component.
 * @param {object} theme The theme object.
 * @returns {object} An object with the overridden styles.
 * @example
 * const theme = {
 *   customShadows: {
 *     z20: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
 *   },
 * };
 * const styles = Autocomplete(theme);
 */
export default function Autocomplete(theme) {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.z20,
        },
      },
    },
  };
}
